import { Grid, Modal, Typography, withStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { DATE_FORMATS, DateUtils } from "shared/dateUtils";
import ConciliationDetailsModalTable from "./conciliationDetailsModalTable";
import NoDetailedOperationsFeedback from "./noDetailedOperationsFeedback";

export const ConciliationDetailsModal = ({
  categoryName,
  categoryOperations = [],
  classes,
  endDate,
  isOpen,
  onClose,
  startDate,
}) => {
  const { t } = useTranslations();

  const hasOperations = categoryOperations.length > 0;

  const startDateFormatted = DateUtils.parse(startDate).format(
    DATE_FORMATS["DD/MM/YYYY"]
  );
  const endDateFormatted = DateUtils.parse(endDate).format(
    DATE_FORMATS["DD/MM/YYYY"]
  );

  const dateRangeText = `${t(
    "common:fields.start-date"
  )}: ${startDateFormatted} | ${t(
    "common:fields.end-date"
  )}: ${endDateFormatted}`;

  return (
    <div className={classes.boxModal}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={isOpen}
        onBackdropClick={onClose}
      >
        <Grid
          alignItems="flex-start"
          className={classes.modalContent}
          container
          id="modal-container"
        >
          <Grid item xs={12} className={classes.header}>
            <Typography variant="h6" className={classes.headerContent}>
              {t("movements:operations-history")}
            </Typography>
            <CloseIcon className={classes.closeIcon} onClick={onClose} />
          </Grid>

          <Grid item xs={6} className={classes.name}>
            {categoryName}
          </Grid>

          <Grid item xs={6} className={classes.detailsContainer}>
            {hasOperations && (
              <Typography className={classes.dataTexto}>
                {dateRangeText}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            {hasOperations ? (
              <ConciliationDetailsModalTable
                operationItems={categoryOperations}
              />
            ) : (
              <NoDetailedOperationsFeedback />
            )}
          </Grid>
        </Grid>
      </Modal>
    </div>
  );
};

const styles = () => ({
  boxModal: {
    overflow: "auto",
  },
  modalContent: {
    margin: "100px auto",
    padding: "40px 40px",
    width: "70%",
    maxHeight: "70%",
    backgroundColor: "#ffffff",
    outline: "none",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.5)",
    borderRadius: 16,
  },
  header: {
    display: "flex",
    marginTop: "16px",
    marginBottom: "16px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerContent: {
    position: "relative",
    fontSize: "18px",
    fontWeight: "500",
    letterSpacing: "-0.1px",
    color: "rgba(51, 50, 56, 0.84)",
  },
  name: {
    height: "32px",
    textAlign: "left",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: "normal",
    color: "#333333",
  },
  detailsContainer: {
    height: "32px",
    textAlign: "right",
    fontFamily: "Roboto",
    fontSize: "14px",
    letterSpacing: "normal",
    color: "#333333",
  },
  closeIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    objectFit: "contain",
  },
});

export default withStyles(styles)(ConciliationDetailsModal);
